import React from 'react';
import Lottie from 'lottie-react';
import "./Common_main_banner_lottie.css";

function Common_main_banner_lottie({animationData}) {
  return (
    <section className='Common_main_banner_lottie'>
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        className="arrow_lottie"
      />
    </section>
  );
}

export default Common_main_banner_lottie;
